import { Benefit } from '../../../@types/benefits';
import { UserInteractionStatus } from '../../../@types/benefitsViewedStatus';

export type UserInteractionsApiResponse = {
  numberOfUnviewedBenefits: number;
  userInteractions: {
    type: string;
    page: 'BENEFITS_PAGE';
  }[];
};

export const userInteractionStatusToApp = ({
  numberOfUnviewedBenefits,
  userInteractions,
}: UserInteractionsApiResponse): UserInteractionStatus => ({
  numberOfUnviewedBenefits,
  viewedBenefits: Object.values(Benefit).filter((benefit) =>
    userInteractions.find((userInteraction) => userInteraction.type.includes(benefit)),
  ),
  legalInsuranceHintDismissed: !!userInteractions.find(
    (userInteraction) => userInteraction.type === 'LEGAL_INSURANCE_TIP_VIEWED',
  ),
});
